import { FormControl, Typography } from '@mui/material';
import clsx from 'clsx';
import {
  Controller,
  ControllerProps,
  // Validate,
  useFormContext,
} from 'react-hook-form';
import { Checkbox } from '../../Checkbox';
// import { ErrorMessage } from '@hookform/error-message';

export interface NotificationsFormPros extends Omit<ControllerProps, 'render'> {
  label?: string;
  disableEmailField?: boolean;
}

export const Notification = ({
  name,
  label,
  rules,
  disableEmailField,
  ...props
}: NotificationsFormPros) => {
  const methods = useFormContext();
  // const validateNotifications: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // Validate<any> | Record<string, Validate<any>> = () => {
  //   const notification: boolean[] = methods.getValues(name);
  //   const isValid = Object.values(notification).reduce(
  //     (acc, notificationType) => acc || notificationType,
  //     false
  //   );
  //   !isValid
  //     ? methods.setError(name, {
  //         message: 'Escolha pelo menos um meio de notificação',
  //       })
  //     : methods.clearErrors(name);
  //   return isValid;
  // };
  return (
    <FormControl component="fieldset">
      <Typography
        className={clsx(
          { 'text-mui-error': methods.formState.errors[name] },
          'mb-1 font-bold'
        )}
        alignSelf="center"
      >
        {label}
        {/* {<span className="ml-1 text-mui-error">*</span>} */}
      </Typography>
      <Controller
        name={name}
        {...props}
        render={({ formState: { errors } }) => (
          <>
            <div aria-labelledby={name} className="flex">
              {/* <Checkbox
                name={name + '.notifySMS'}
                label="SMS"
                // rules={{ validate: validateNotifications }}
              /> */}
              <Checkbox
                name={name + '.notifyEmail'}
                label="Email"
                disabled={disableEmailField}
                // rules={{ validate: validateNotifications }}
              />
              <Checkbox
                name={name + '.notifyWhatsapp'}
                label="WhatsApp"
                // rules={{ validate: validateNotifications }}
              />
            </div>
            {/* <ErrorMessage
              name={name}
              errors={errors}
              render={({ message }) => (
                <Typography
                  className={clsx(
                    { 'text-mui-error': errors[name] },
                    'ml-4 mb-1'
                  )}
                  alignSelf="start"
                >
                  {message}
                </Typography>
              )}
            /> */}
          </>
        )}
      />
    </FormControl>
  );
};
